import {RouterProps} from "../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {UserExpValueObject} from "../../../data/value-object/user/UserExpValueObject";
import {useEffect} from "react";
import {UserExpIO} from "../../../io/UserIO";
import {Body1, Caption1Strong, Spinner, Tab, TabList} from "@fluentui/react-components";
import {UserExpDomain} from "../../../data/domain/user/UserExpDomain";
import {UserExpDescriptor} from "../../../data/descriptor/user/UserExpDescriptor";
import {mapByKey} from "../../../util/ObjectUtil";
import {UserExpDescription} from "../../../data/description/user/UserExpDescription";

enum Panel {
    Default,
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ userExpId: string }>()
    const item = useStatePair<UserExpValueObject | undefined>(undefined)

    useEffect(() => {
        if (params.userExpId !== undefined) {
            UserExpIO
                .getById(BigInt(params.userExpId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: UserExpValueObject
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)

    return <>
        <div className={props.styles.row16}>
            <TabList
                selectedValue={panel.value}
                onTabSelect={(_, data) => panel.setter(data.value as Panel)}
                vertical>
                <Tab value={Panel.Default}>상세</Tab>
            </TabList>
            <DefaultPanel
                {...props}
                panel={panel.value} />
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof UserExpDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "type":
        case "amount":
        case "lastAccumulation":
        case "inDay":
        case "inWeek":
        case "inMonth":
        case "inQuarter":
        case "inHalf":
        case "inYear":
        case "createdAt":
            return <Body1>{UserExpDescriptor[props.itemKey](props.item)}</Body1>
        case "userId":
            return <a href={`/users/${props.item.userId}`}><Body1>{UserExpDescriptor[props.itemKey](props.item)}</Body1></a>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{UserExpDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}

type PanelProps = PageProps & {
    panel: Panel
    children?: false | JSX.Element | JSX.Element[]
}

function DefaultPanel(props: PanelProps) {
    return <>
        {props.panel === Panel.Default && <>
            <div className={props.styles.column16}>
                {mapByKey(UserExpDescription, key => <>
                    <div className={props.styles.column4}>
                        <Caption1Strong>{UserExpDescription[key]}</Caption1Strong>
                        <PropertyBody
                            {...props}
                            itemKey={key}/>
                    </div>
                </>)}
                {props.children}
            </div>
        </>}
    </>
}